module.exports = __webpack_public_path__ + "static/media/404.f3e1fa98.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/404.svg
// module id = 769
// module chunks = 0